'use client';

import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface GetButtonProps {
  disabled: boolean;
  buttonText: string;
  onClick: () => Promise<void>;
}

const styles = {
  buttonTextDisabled: 'text-label-secondary',
  buttonIcon: 'absolute left-5 w-5.5',
  button:
    'sticky bottom-10 w-full left-5 right-5 bg-fill-button rounded-xl py-5 mt-8 block cursor-pointer',
  buttonDisabled: 'bg-fill-toast cursor-not-allowed',
  buttonText: 'text-label-black font-extrabold text-base text-center',
};

export const GetButton: FC<GetButtonProps> = ({
  disabled,
  buttonText,
  onClick,
}) => (
  <button
    onClick={onClick}
    className={twMerge(styles.button, disabled && styles.buttonTextDisabled)}
  >
    <div
      className={twMerge(
        styles.buttonText,
        disabled && styles.buttonTextDisabled,
      )}
    >
      {buttonText}
    </div>
  </button>
);
